import { drawPositionTypeIds } from '../eventConstants';

export function wonGame(players, playerId) {
    if (players.winner1 === playerId) {
        return true;
    }

    if (players.winner2 !== undefined && players.winner2 === playerId) {
        return true;
    }

    return false;
}

export const position1winner = (match, playersDictByMemberId, teamsDict) => {
    if (match.position1 && match.position1.memberId && match.position1.typeId === drawPositionTypeIds.PLAYER) {
        return wonGame(match.result.players, playersDictByMemberId[match.position1.memberId].playerId);
    }

    if (match.position1 && match.position1.id && match.position1.typeId === drawPositionTypeIds.TEAM) {
        return wonGame(match.result.players, playersDictByMemberId[teamsDict[match.position1.teamId]?.members[0]]?.playerId);
    }

    return false;
};
